// @core/api/endpoints/userprofile/search_userprofiles.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SearchUserprofilesResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Search user profiles (privacy-aware)
 * Searches user profiles by query string matching username, display_name, first_name, last_name. Returns compact results with privacy-aware field projection. Profiles with show_in_search=false or private visibility are excluded.
 */
export async function SearchUserprofiles(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    q?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<SearchUserprofilesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/search`;
  const requestOptions = options;
  return client.get<SearchUserprofilesResponse>(requestPath, { ...requestOptions, params });
}
